import { ServiceFactory } from '@/services/ServiceFactory'
import { CustomLayerTypesEnum } from '@/bundles/Map/helpers/customLayers/customLayerTypes';

import * as constants from './spatial-types'

const GeoService = ServiceFactory.get('geo')

export default {
  async [constants.GET_LAYERS_NEW] ({ rootState, commit }) {
    try {
      const params = [
        {
          name: 'types',
          value: [
            CustomLayerTypesEnum.industrial,
            CustomLayerTypesEnum.office,
            CustomLayerTypesEnum.retail,
            CustomLayerTypesEnum.multi_family,
            CustomLayerTypesEnum.farm_and_ranch,
            CustomLayerTypesEnum.labor,
            CustomLayerTypesEnum.residential,
            CustomLayerTypesEnum.transportation
          ]
        }
      ];

      const { data } = await GeoService.getLayersTreeNew({
        params,
        token: rootState.idToken,
      });

      commit(constants.SET_LAYERS_NEW, data);
    } catch (e) {
      throw e
    }
  },
}
